import React from 'react';
import { useTranslation } from 'react-i18next';
import Particles from 'react-particles';
import { loadSlim } from 'tsparticles-slim';
import type { Engine } from 'tsparticles-engine';
import { ParticlesOptions } from '@/config/particles';
import LanguageSwitch from '@/components/LanguageSwitch';
import logo from '@/assets/q.svg';
import '../login/index.scss';
import { RouteConfig } from '@/types/route';
import PageTransition from '@/components/PageTransition';
import ConfigStore from '@/store/ConfigStore';
import { MoonOutlined, SunOutlined } from '@ant-design/icons';

export const routeConfig: RouteConfig = {
    title: '隐私政策',
    // icon: <StopOutlined />,
    layout: false,
    
    // hidden: true // 在菜单中隐藏
}

const PrivacyPage: React.FC = () => {
    const { t } = useTranslation();
    const particlesInit = async (engine: Engine) => {
        await loadSlim(engine);
    };

    const PrivacyContent: React.FC = () => (
        <div
            className=''
            style={{
                fontFamily: 'Arial, sans-serif',
                lineHeight: 1.6,
                maxWidth: '800px',
                margin: 'auto',
            }}
        >
            <h1 style={{ textAlign: 'center' }}>Privacy Policy</h1>
            <p style={{ textAlign: 'center' }}>Effective Date: 16 June 2025</p>

            <p>This Privacy Policy describes how <strong>TGX LTD</strong> ("we", "us", or "our") collects, uses, and protects information in connection with the use of our decentralized cryptocurrency exchange platform ("Platform").</p>

            <h2>1. No Collection of Personal Information</h2>
            <p><strong>TGX LTD</strong> is a non-custodial and decentralized platform. We do <strong>not</strong> collect or store personal information such as names, email addresses, phone numbers, government-issued IDs, or any other identifying information.</p>

            <h2>2. Wallet-Based Access</h2>
            <p>Access to the Platform is enabled solely through decentralized wallets. Your interactions are linked only to your public blockchain address. We do not have access to your private keys or the contents of your wallet.</p>

            <h2>3. On-Chain Data</h2>
            <p>All transaction data is recorded on the blockchain and is publicly accessible. <strong>TGX LTD</strong> does not control or alter blockchain data. Users should be aware that while pseudonymous, blockchain activity is publicly visible and may be analyzed by third parties.</p>

            <h2>4. Use of Cookies and Analytics</h2>
            <p>We may use minimal cookies or browser storage for functional purposes only—such as remembering interface preferences or language settings. We do not use tracking cookies or third-party analytics tools to monitor user behavior.</p>

            <h2>5. Third-Party Services</h2>
            <p>The Platform may link to third-party tools (e.g., wallet providers, node infrastructure, or token data sources). We are not responsible for the privacy practices of these third parties. Please refer to their privacy policies when using their services.</p>

            <h2>6. Security Practices</h2>
            <p>We implement reasonable measures to secure our interface and smart contracts. However, given the decentralized nature of the Platform, you are solely responsible for safeguarding your wallet credentials and securing your own environment.</p>

            <h2>7. Children's Privacy</h2>
            <p>The Platform is not intended for use by individuals under the age of 18. We do not knowingly collect any information from minors.</p>

            <h2>8. Changes to This Policy</h2>
            <p>We may revise this Privacy Policy from time to time. Any changes will be posted on this page with an updated effective date. Continued use of the Platform after changes constitutes your acceptance of the new policy.</p>

            <h2>9. Contact</h2>
            <p>If you have any questions or concerns regarding this Privacy Policy, please contact us at: <strong>support@qb.finance</strong>.</p>
        </div>
    );

    return (
        <PageTransition>
            <div className="term-page">
                <div className="term-container">
                    <Particles
                        className="absolute inset-0"
                        init={particlesInit}
                        options={ParticlesOptions}
                    />

                    <div className="absolute top-4 right-4 flex items-center space-x-3">
                        <LanguageSwitch />
                        <button
                            className="theme-switch"
                            onClick={() => ConfigStore.setThemeMode(ConfigStore.isDark ? 'light' : 'dark')}
                        >
                            {ConfigStore.isDark ? (
                                <SunOutlined className="text-amber-500" />
                            ) : (
                                <MoonOutlined className="text-blue-500" />
                            )}
                        </button>
                    </div>

                    <div
                        className="term-form-container"
                        style={{
                            maxHeight: '80vh', // Set maximum height
                            overflowY: 'auto', // Enable vertical scrolling
                            padding: '20px',
                            borderRadius: '8px',
                        }}
                    >
                        <div className="header-section">
                            <img src={logo} alt="Logo" className="logo" />
                        </div>
                        <div>
                            <PrivacyContent />
                        </div>
                    </div>

                    <div className="copyright">
                        Copyright © {new Date().getFullYear()} QuBit Affiliate
                    </div>
                </div>
            </div>
        </PageTransition>
    );
}

export default PrivacyPage;